module.exports = __webpack_public_path__ + "static/img/faq_service08.759ef7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/faq_service08.png
// module id = bUVl
// module chunks = 2